<template>
  <button class="Drop-Menu-Item" @click="togglePin">
    <div class="Drop-Menu-Item__svg-box">
      📌
    </div>
    {{ isPinned ? 'Открепить' : 'Закрепить' }}
  </button>
</template>

<script setup>
import {computed, defineProps} from 'vue';
import {Props} from './scripts/props.js';
import {useStore} from 'vuex';
//-----------------------------------------
const store = useStore();
const props = defineProps(Props());
const emit = defineEmits(['close']);
//-----------------------------------------
const CONTEXT = (props.commentsPlace === 'popup') ? 'popupComments' : 'contentPageComments';
const COMMENT = computed(() =>
  store.state.ContentSystem.Comments[CONTEXT].list.find(item => item.id == props.commentId)
);
const POST = store.state.ContentSystem.Alpha.list[COMMENT.object_pk] || store.state.ContentSystem.Infonoise.list[COMMENT.object_pk];
//-----------------------------------------
//Проверить, закреплен ли комментарий
const isPinned = computed(() => COMMENT.value?.pinned_comment);
//-----------------------------------------
//Закрепить/открепить комментарий
const togglePin = async () => {
  sendEmitClose();
  if (isPinned.value) {
    await store.dispatch('ContentSystem/Comments/unpinComment', {
      commentId: props.commentId,
      context: CONTEXT,
      objectPk: COMMENT.value.object_pk
    });
  } else {
    await store.dispatch('ContentSystem/Comments/pinComment', {
      commentId: props.commentId,
      context: CONTEXT,
      objectPk: COMMENT.value.object_pk
    });
  }
};
//Отправляем событие закрытие дропдауна
const sendEmitClose = () => emit('close');
</script>

<style lang="scss">
@import '../../../../styles/Drop-Menu-Item.scss';
</style>
